import { render } from "./HeroiconsOutlineDotsCircleHorizontal.vue?vue&type=template&id=76503c16"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDotsCircleHorizontal.vue"]])

export default __exports__